import React, { ReactNode } from 'react';

import Textarea from 'components/Textarea';

import Field from './Field';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const TextAreaField = ({
  name,
  label,
  description,
  placeholder,
  maxLength,
  ...props
}: {
  description?: string | ReactNode;
  label?: string;
  maxLength?: number;
  name: string;
  onUpdateValue?: (arg0: string) => void;
  placeholder?: string;
  rows?: number;
  value?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (arg0: Record<string, any>) => void;
  onKeyPress?: (arg0: React.KeyboardEvent) => void;
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <Textarea
        id={id}
        name={name}
        value={value}
        hasError={hasError}
        data-qa-id={qaId}
        maxLength={maxLength}
        onChange={(e) => {
          updateValue(e.target.value);

          if (props.onUpdateValue) {
            props.onUpdateValue(e.target.value);
          }
        }}
        placeholder={placeholder}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    )}
  />
);

// eslint-disable-next-line import/no-default-export
export default TextAreaField;
